export const business = {
  name: 'Innova Pools & Systems',
  tagline: 'Pool Renovation & Repair',
  phoneDisplay: '(689) 326 - 6071',
  phoneHref: 'tel:+16893266071',
  email: 'innovapoolsystems@gmail.com',
  city: 'Orlando, Florida'
};
export const images = {
  logo: 'https://cdn.magicpatterns.com/uploads/bVscuk9K4b2hqpaFJaojM5/innova_LOGO.png',
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/326796fa-1db2-4892-a8c9-7cd04ceea838.jpg',
  before: 'https://cdn.magicpatterns.com/patterns/generated-images/127dbd2c-5368-405a-89ed-291ea21fe0df.jpg',
  after: 'https://cdn.magicpatterns.com/patterns/generated-images/996e560d-d532-48d0-8d55-d5d2fb7fe2f0.jpg',
  tile: 'https://cdn.magicpatterns.com/patterns/generated-images/ed813c54-d89e-4161-8bb8-47bd1647bd1f.jpg',
  deck: 'https://cdn.magicpatterns.com/patterns/generated-images/a7ae178a-9c5f-4b33-9c5f-1ac475988461.jpg',
  equipment: 'https://cdn.magicpatterns.com/patterns/generated-images/0bae3ea3-dc07-4373-8db4-5d75f4c60cae.jpg',
  plaster: 'https://cdn.magicpatterns.com/patterns/generated-images/f1846da7-b943-4c40-a7db-37a0c415ad5e.jpg',
  stained: 'https://cdn.magicpatterns.com/patterns/generated-images/9d01c834-4d5a-4e30-b4ba-3606905e869c.jpg',
  coping: 'https://cdn.magicpatterns.com/patterns/generated-images/59b413dc-6eb4-40d1-8373-510b5a20e1b4.jpg',
  completed: 'https://cdn.magicpatterns.com/patterns/generated-images/fd075663-a8b9-4ff6-b561-a7b53e7a7138.jpg'
};
export const serviceCities = ['Orlando', 'Kissimmee', 'Winter Garden', 'Clermont'];
export const citySuggestions = ['Orlando', 'Kissimmee', 'Winter Garden', 'Clermont', 'Windermere', 'Ocoee', 'Apopka', 'Winter Park', 'St. Cloud', 'Davenport', 'Celebration', 'Oviedo'];